(function () {
  'use strict';

  function openModal() {
    var modal = document.getElementById('rh-contact-modal');
    if (!modal) return;
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    var firstInput = modal.querySelector('input:not([type="hidden"])');
    if (firstInput) setTimeout(function () { firstInput.focus(); }, 50);
  }

  function closeModal() {
    var modal = document.getElementById('rh-contact-modal');
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  function onDocClick(e) {
    if (e.target.closest('.js-bar-closer')) return;
    if (e.target.closest('[data-contact-trigger]')) {
      e.preventDefault();
      openModal();
      return;
    }
    if (e.target.closest('.rh-contact-modal__close') ||
        e.target.classList.contains('rh-contact-modal__backdrop')) {
      closeModal();
    }
  }

  function onKeyDown(e) {
    if (e.key === 'Escape') closeModal();
  }

  function onFormSubmit(e) {
    var form = e.target;
    if (form.tagName !== 'FORM') return;
    if (!form.closest('#rh-contact-modal')) return;
    e.preventDefault();

    var successEl = form.querySelector('.rh-contact-form__success');
    var errorEl   = form.querySelector('.rh-contact-form__error');
    var submitBtn = form.querySelector('.rh-contact-form__submit');
    var nameEl    = form.querySelector('[name="contact[name]"]');
    var emailEl   = form.querySelector('[name="contact[email]"]');
    var bodyEl    = form.querySelector('[name="contact[body]"]');
    var cityEl    = form.querySelector('[name="contact[city]"]');

    if (successEl) successEl.hidden = true;
    if (errorEl)   errorEl.hidden   = true;

    var valid = nameEl  && nameEl.value.trim() &&
                emailEl && emailEl.value.trim() && emailEl.value.includes('@') &&
                bodyEl  && bodyEl.value.trim() &&
                cityEl  && cityEl.value.trim();

    if (!valid) {
      if (errorEl) errorEl.hidden = false;
      return;
    }

    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Sending...'; }

    // Fetch a fresh bot-protection token from Shopify's contact page, then POST
    fetch('/contact', { credentials: 'include' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc    = parser.parseFromString(html, 'text/html');
        var params = new URLSearchParams(new FormData(form));

        // Inject any extra hidden fields Shopify adds (bot-protection token etc.)
        var contactForm = doc.querySelector('form[action*="/contact"]');
        if (contactForm) {
          contactForm.querySelectorAll('input[type="hidden"]').forEach(function (input) {
            if (!input.name) return;
            // Always use the fresh value from Shopify's rendered page
            params.set(input.name, input.value);
          });
        }

        return fetch('/contact', {
          method:      'POST',
          credentials: 'include',
          headers:     { 'Content-Type': 'application/x-www-form-urlencoded' },
          body:        params.toString()
        });
      })
      .then(function (res) {
        if (res.status < 500) {
          if (successEl) successEl.hidden = false;
          form.reset();
        } else {
          if (errorEl) errorEl.hidden = false;
        }
      })
      .catch(function () {
        if (errorEl) errorEl.hidden = false;
      })
      .finally(function () {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Send Message'; }
      });
  }

  function init() {
    document.addEventListener('click', onDocClick);
    document.addEventListener('keydown', onKeyDown);
    document.addEventListener('submit', onFormSubmit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
